// Frontend React MUI Component

import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { getMultipartHeader } from "../../utils/util";
import { API_ENDPOINT } from "../../utils/constants";

const UploadContactsForm = () => {
  const [listName, setListName] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!listName || !file) {
      setMessage("Please provide a list name and select a CSV file.");
      return;
    }

    setLoading(true);
    setMessage("");

    const formData = new FormData();
    formData.append("listName", listName);
    formData.append("csvFile", file);

    try {
      // Assuming you have authentication token; add to headers if needed
      const response = await axios.post(
        `${API_ENDPOINT}/multipart/upload-contacts-csv`,
        formData,
        getMultipartHeader()
      );
      setMessage(response.data.message);
    } catch (error) {
      setMessage(
        "Error uploading contacts: " +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ maxWidth: 400, m: "auto", p: 2 }}
    >
      <Typography variant="h6" gutterBottom>
        Upload Contacts List
      </Typography>
      <TextField
        label="Contact List Name"
        value={listName}
        onChange={(e) => setListName(e.target.value)}
        fullWidth
        margin="normal"
        required
      />
      <input
        type="file"
        accept=".csv"
        onChange={handleFileChange}
        style={{ marginBottom: 16 }}
        required
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={loading}
        fullWidth
      >
        {loading ? <CircularProgress size={24} /> : "Upload"}
      </Button>
      {message && (
        <Typography color="error" sx={{ mt: 2 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default UploadContactsForm;
